import React from 'react';
import {
    GoogleMap,
    Marker,
    withGoogleMap,
    withScriptjs,
} from 'react-google-maps';

const MyMapComponent = withScriptjs(
    withGoogleMap((props) => (
        <GoogleMap
            defaultZoom={8}
            defaultCenter={{ lat: 46.84358489999999, lng: -1.8808550999999625 }}
        >
            {props.isMarkerShown && (
                <Marker
                    position={{
                        lat: 46.84358489999999,
                        lng: -1.8808550999999625,
                    }}
                />
            )}
        </GoogleMap>
    )),
);

export default class GoogleMapComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <MyMapComponent
                isMarkerShown
                googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
            />
        );
    }
}

GoogleMap.propTypes = {};



// WEBPACK FOOTER //
// ./src/components/GoolgeMap.jsx